import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Button from '../../components/common/Button'
import Input from '../../components/common/Input'
import { validateRegisterForm, mapServerFieldErrors, hasErrors } from '../../utils/validation'
import './Auth.css'

const Register = () => {
  const navigate = useNavigate()
  const { register } = useAuth()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    role: 'student',
  })
  const [fieldErrors, setFieldErrors] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    // Clear the error for the field being edited + any general error.
    setFieldErrors((prev) => ({ ...prev, [name]: undefined }))
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    const validationErrors = validateRegisterForm(formData)
    if (hasErrors(validationErrors)) {
      setFieldErrors(validationErrors)
      return
    }
    setFieldErrors({})
    setLoading(true)

    try {
      const result = await register(formData)
      if (result.success) {
        navigate('/')
      } else if (result.errors) {
        // Backend validation errors (422) → clear per-field Arabic messages.
        setFieldErrors(mapServerFieldErrors(result.errors))
      } else {
        setError(result.message || 'فشل إنشاء الحساب')
      }
    } catch (err) {
      setError('حدث خطأ أثناء إنشاء الحساب')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <Header />
      <main className="auth-main">
        <div className="auth-container">
          <div className="auth-card">
            <h1 className="auth-title">إنشاء حساب جديد</h1>
            <p className="auth-subtitle">انضم إلى آلاف المتعلمين</p>

            <form onSubmit={handleSubmit} className="auth-form" noValidate>
              <Input
                label="الاسم الكامل"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={fieldErrors.name}
                fullWidth
              />

              <Input
                label="البريد الإلكتروني"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={fieldErrors.email}
                fullWidth
              />

              <Input
                label="رقم الهاتف"
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={fieldErrors.phone}
                helperText="اختياري"
                fullWidth
              />

              <Input
                label="كلمة المرور"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                error={fieldErrors.password}
                helperText="8 أحرف على الأقل"
                fullWidth
              />

              <Input
                label="تأكيد كلمة المرور"
                type="password"
                name="password_confirmation"
                value={formData.password_confirmation}
                onChange={handleChange}
                error={fieldErrors.password_confirmation}
                fullWidth
              />

              {error && <div className="auth-error">{error}</div>}

              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                loading={loading}
                disabled={loading}
              >
                إنشاء حساب
              </Button>

              <div className="auth-footer">
                <span>لديك حساب بالفعل؟</span>
                <Link to="/login" className="auth-link-primary">
                  تسجيل الدخول
                </Link>
              </div>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Register

